module.exports = __webpack_public_path__ + "static/media/ico-event-date.6ef80f53.svg";